export default "__VITE_ASSET__BlyJCZ81__"